import { useState, useEffect } from "react";
import { Grid, Box, Stack, List, ListItem, Divider, Typography } from "@gti-controls-v2/web-core";
import { GetIconById } from "../../../components/icons";

const Modules = ({ Employee, empresaData, data }) => {
    const [empresasResult, setEmpresasResult] = useState([]);
    const [totalModulos, setTotalModulos] = useState([]);

    useEffect(() => {
        cargarModulosEmpresa(empresaData, data);
        // eslint-disable-next-line
    }, [Employee]);


    const cargarModulosEmpresa = async (empresaData, modulosData) => {
        setTotalModulos(modulosData);

        setEmpresasResult(empresaData);
    };

    const getModulesByCompany = (empresaID) => {
        const resultado = totalModulos.filter((item) => item.EmpresaId === empresaID)

        if (resultado.length > 0) {
            return resultado[0].Modulos;
        }
        else {
            return [];
        }
    };

    return (
        <>
            {
                totalModulos.length > 0 && empresasResult.length > 0 && empresasResult.map((company) => {
                    return (
                        <>
                            <Grid container sx={{ backgroundColor: '#ffffff', borderRadius: 2, padding: 2, marginTop: 4 }}>
                                <List>
                                    <ListItem>
                                        <div><b>{company.EmpresaNombre}</b></div>
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem>
                                        <Grid container spacing={2} sx={{ width: 1000 }}>
                                            {
                                                getModulesByCompany(company.EmpresaID).map(({ ModuloNombre, ModuloIcono, }, index) => {
                                                    const Icon = GetIconById(ModuloIcono); // Asumiendo que GetIconById retorna la ruta del icono
                                                    
                                                    return (
                                                        <Grid item xs={2} id={index}>
                                                            <Box 
                                                                sx={{ 
                                                                    textAlign: "center",
                                                                    backgroundColor: "#e1f1fd", 
                                                                    
                                                                    borderRadius: "50%",
                                                                    width: "80px", // Ajusta el tamaño del círculo según lo necesario
                                                                    height: "80px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    margin: "0 auto", // Centra el círculo horizontalmente
                                                                }}
                                                            >
                                                                <Stack direction="column">
                                                                    <Box
                                                                        component="img"
                                                                        src={Icon}
                                                                        alt={`Icono ${index}`}
                                                                        sx={{
                                                                            width: '40px',
                                                                            height: '40px',
                                                                            objectFit: 'contain',
                                                                        }}
                                                                    />
                                                                </Stack>
                                                            </Box>
                                                            <Typography variant="body2" sx={{ marginTop: '8px', textAlign: "center" }}>
                                                                {ModuloNombre}
                                                            </Typography>
                                                        </Grid>
                                                    );
                                                })
                                            }
                                        </Grid>
                                    </ListItem>
                                </List>
                            </Grid>
                            <br />
                        </>
                    );
                })
            }

        </>
    );
};

export default Modules;